import React from 'react';
import { usePremium } from 'hooks/usePremium';
import { useRouting } from 'hooks/useRouting';
import PremiumModal from 'components/features/modal/PremiumModal';
import Loading from '../loading/Loading';

type Props = {
  children: React.ReactNode;
  layoutPattern: number;
};

// プレミアムモーダル表示用
export const PremiumCheck: React.FC<Props> = props => {
  const [premiumStatus] = usePremium();
  const routing = useRouting();

  return premiumStatus.status !== 'loading' ? (
    <>
      {premiumStatus.status === 'isNotPremium' && (
        <PremiumModal
          layoutPattern={props.layoutPattern}
          onClose={() => routing.pushRouting({ path: '/home' }, true)}
        />
      )}
      {premiumStatus.status === 'isPremium' && props.children}
    </>
  ) : null;
};

type Props2 = {
  children: React.ReactNode;
  content: JSX.Element;
};

// プレミアム画面表示用
export const PremiumCheck2: React.FC<Props2> = props => {
  const [premiumStatus] = usePremium();

  if (premiumStatus.status === 'loading')
    return (
      <>
        <Loading loading style={{ marginTop: '2rem' }} />
      </>
    );
  if (premiumStatus.status === 'isPremium') return <>{props.children}</>;

  return props.content;
};
